import formatNumber from "../../../../utils/formatNumber";
import FormLabel from "../../FormLabel/FormLabel";
import SpecialInputProjectPartnersExpenses from "../SpecialInputProjectPartnersExpenses/SpecialInputProjectPartnersExpenses";
import Style from "./index.module.css";

const SpecialInputProjectPartnerExpensesContainer = ({
  partnersList,
  setPartnersList,
  partnerExpense = Infinity,
  label,
}) => {
  const handleDelete = (e) => {
    const value = e.target.nextElementSibling.textContent;
    const otherPartnerName = value.split(" ")[0];
    const newPartnersList = partnersList.filter(
      (partner) => partner.name !== otherPartnerName
    );
    setPartnersList(newPartnersList);
  };

  const addNewPartnerProp = (newPartner) => {
    const otherPartnerPrice = newPartner.budget;

    const otherPartnersExpense = partnersList.reduce((acc, partner) => {
      return acc + parseInt(partner.budget, 10);
    }, 0);

    if (otherPartnersExpense + parseInt(otherPartnerPrice) > partnerExpense) {
      alert("Ukupni proračun partnera se ne smije prekoračit");
      return -1;
    }
    setPartnersList((prevList) => [...prevList, newPartner]);
    return 0;
  };

  return (
    <div className={Style.SpecialInputProjectPartnerExpensesContainer}>
      <FormLabel label={label} />
      <SpecialInputProjectPartnersExpenses
        addNewPartnerProp={addNewPartnerProp}
      />
      <ul>
        {partnersList.map((partner, index) => (
          <li key={index}>
            <button className={Style.DeleteMemberButton} onClick={handleDelete}>
              UKLONI
            </button>
            <span>
              {partner.name} {formatNumber(partner.budget)} EUR
            </span>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default SpecialInputProjectPartnerExpensesContainer;
